import React, { type ReactNode, Suspense } from "react";
import type { KnownApiError } from "src/api/generated/errors/knownApiError";

export interface KnownApiErrorViewProps<TError extends KnownApiError> {
	additionalActions?: ReactNode;
	error: TError;
	reload?: () => void;
	showSolveWithAiButton: boolean;
	renderOutdatedFrontendVersionMessage: () => ReactNode;
}

// Lazy load to break circular dependencies.
const ConfiguratorErrorView = React.lazy(() =>
	import("src/components/views/erp/configurator/errors/ConfiguratorErrorView.tsx").then((m) => ({
		default: m.ConfiguratorErrorView,
	})),
);

export const KnownApiErrorView = <TError extends KnownApiError>(props: KnownApiErrorViewProps<TError>) => {
	switch (props.error.type) {
		case "CONFIGURATOR_ERROR":
			return (
				<Suspense fallback={null}>
					<ConfiguratorErrorView {...props} />
				</Suspense>
			);
	}
};
